import React, { useState } from "react";
import MyModal from "../UI/modal/MyModal";
import { monthNames } from "../../common/links";
import AllForecastModalBody from "./allForecastModalBody";

const Forecast = function ({ children, forecast,...props}){
    let classname = forecast.kind+"_forecast" + " forecast";
    let fcId = classname+"_"+forecast.id;
    let caption;
    if (forecast.kind === "year") caption = forecast.date.split('-')[0] + " - " + forecast.theme
    if (forecast.kind === "month") caption = monthNames[forecast.date.split('-')[1]] + " - " + forecast.theme
    if (forecast.kind === "day") caption = forecast.date.split('T')[0] + " - " + forecast.theme
    const [modal, setModal] = useState(false);

    const modalChange = function(){
        setModal(!modal);
    }

    return (
        <div {...props} id={fcId} className={classname} onClick={() => modalChange()}>
            <MyModal
                visible={modal}
                setVisible={setModal}
                style={{width: "50%"}}
            >
                <AllForecastModalBody forecast={forecast} modalKind={"PATCH"} closeSelf={setModal}/>
            </MyModal>
            <span>{caption}</span>
            {children}
        </div>
    );
}
export default Forecast;